import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ContentsService, PaymentMethod } from '@vestiaire/api-sdk-angular';
import { LocaleService } from '@app/core/i18n';

@Component({
  selector: 'vc-footer-payment-mode',
  templateUrl: './footer-payment-mode.component.html',
  styleUrls: ['./footer-payment-mode.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterPaymentModeComponent implements OnInit {
  public payments: Array<PaymentMethod>;
  public isGermany = false;
  public currentCountry: string;

  constructor(private contentsService: ContentsService, private localeService: LocaleService) {}

  ngOnInit() {
    this.currentCountry = this.localeService.getCountry();
    if (this.currentCountry === 'DE') {
      this.isGermany = true;
    }
    this.contentsService.getPaymentMethods().subscribe(
      res => {
        if (res.data) {
          this.payments = res.data;
        }
      },
      () => {
        // No payment method to display
      }
    );
  }
}
